module.exports = __webpack_public_path__ + "img/flkf.ffd99d42.png";